/*
 * Based on: https://github.com/SparebankenVest/react-css-collapse
 */

import * as React from 'react';
import type { AriaAttributes } from 'react';
import { useCollapse } from './useCollapse';

export interface CollapseProps extends AriaAttributes {
    children: React.ReactNode;
    isOpen?: boolean;
    onRest?: () => void;
    className?: string;
    withMarginTransition?: boolean;
}

export const Collapse: React.FC<CollapseProps> = props => {
    const { children, onRest, isOpen = false, className, withMarginTransition, ...rest } = props;

    const content = React.useRef(null);

    const { toggleStyles, style } = useCollapse({
        isOpen,
        content,
    });

    const onTransitionEnd = (event: React.TransitionEvent<HTMLDivElement>) => {
        if (event.target === content.current && event.propertyName === 'height') {
            toggleStyles();

            onRest?.();
        }
    };

    const styles = {
        willChange: withMarginTransition ? 'height, margin' : 'height',
        ...style,
    };

    return (
        <div {...rest} ref={content} style={styles} className={className} onTransitionEnd={onTransitionEnd}>
            {children}
        </div>
    );
};
